// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k9G7NGpxVCMjsdQO06yY{flex:auto;justify-content:center;align-items:center;width:100%;height:100%;display:flex}.SdblI9y7vZc6oz82eRY3{flex-direction:column;align-items:center;display:flex}.zKgG5FispzQOPR4vMuiZ{background:var(--red-10);border-radius:50%;justify-content:center;align-items:center;width:80px;height:80px;margin-bottom:24px;display:flex}.pcyqjo5DHqwhXVGf3wrc{background:var(--red-60);border-radius:12px;justify-content:center;align-items:center;width:32px;height:32px;display:flex}.dUQSBE9KBQ8tHkxeOTO7{margin-bottom:8px}.KQ4IKsDZwdsyp3opOJng{text-align:center;max-width:448px;margin-bottom:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `k9G7NGpxVCMjsdQO06yY`,
	"content": `SdblI9y7vZc6oz82eRY3`,
	"iconCircle": `zKgG5FispzQOPR4vMuiZ`,
	"iconBox": `pcyqjo5DHqwhXVGf3wrc`,
	"title": `dUQSBE9KBQ8tHkxeOTO7`,
	"description": `KQ4IKsDZwdsyp3opOJng`
};
export default ___CSS_LOADER_EXPORT___;
